import storage from 'redux-persist/lib/storage';
import { SET_QUERY_PARAMS, EMPTY_QUERY_PARAMS, RESET_QUERY_PARAMS } from '../actions/queryParamActions';

// Initial state: empty until URL params are parsed.
const initialState = {};

/**
 * Reducer for queryParams slice.
 * Replaces state with latest URL parameters.
 */
export default function queryParamReducer(state = initialState, action = {}) {
  if (!state) state = initialState;

  switch (action.type) {
    case SET_QUERY_PARAMS:
      return { ...state, ...action.payload };
    case EMPTY_QUERY_PARAMS:
      storage.removeItem('persist:root');
      return undefined;
    case RESET_QUERY_PARAMS:
      state.queryParams = undefined;
      return { state };
    default:
      return state;
  }
}
